module.exports = __webpack_public_path__ + "static/media/chat-not-ok.7b10fe2e.svg";